import React from 'react';
import Layout from '../Components/Layout';
import blog from '../Assets/images/blog-1.png'
import avt from '../Assets/images/avt-1.png'

import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';

function Blog(props) {
    const categories = [
        {
            name: 'View all',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
        {
            name: 'Design',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
        {
            name: 'Product',
            posts: [
                {
                    id: 1,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                    
                },
                {
                    id: 2,
                    img: blog,
                    avt: avt,
                    avtname: 'John',
                    tag: 'Design',
                    title: 'UX Review Presentations',
                    desc: 'How do you create compelling presentations that wow your collogues and impress your managers? ',
                    date: '5h ago',
                    commentCount: 5,
                    shareCount: 2,
                },
            ],
        },
    ]
    return (
        <Layout>
            <section className='common-space-both container'>
                <div className='common-title text-center'>
                    <label className='font-semibold text-[#F0643B] py-4 inline-block text-lg'>Our Blogs</label>
                    <h1 className='text-black'><span>The Latest Writings</span> From Our Team </h1>
                </div>
                <TabGroup className='mt-10'>
                    <div className='flex items-center mobilexl:flex-col'>
                        <TabList className="flex gap-4 bg-[#F4F4F4] p-1 border border-[#57575733] rounded-xl">
                            {categories.map(({ name }) => (
                                <Tab
                                    key={name}
                                    className="rounded-xl py-2 px-3  font-semibold  focus:outline-none 
                          data-[selected]:bg-white data-[selected]:text-black 
                          data-[hover]:bg-gray-200/20"
                                >
                                    {name}
                                </Tab>
                            ))}
                        </TabList>
                        <div className='ml-auto relative mobilexl:w-full mobilexl:mt-3'>
                            <div className='absolute top-1/2 left-2 -translate-y-1/2'>
                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="9.58317" cy="10.0833" r="7.91667" stroke="#575757" strokeWidth="1.5" />
                                    <path d="M15.4165 15.9166L18.3332 18.8333" stroke="#575757" strokeWidth="1.5" stroke-linecap="round" />
                                </svg>
                            </div>
                            <input type='search' placeholder='Search...' className='pl-8 border-[#57575733] w-[300px] mobilexl:w-full' />
                        </div>
                    </div>
                    <TabPanels className="mt-3">
                        {categories.map(({ name, posts }) => (
                            <TabPanel key={name} className="rounded-xl bg-white/5">
                                <ul className='grid grid-cols-3 gap-5 mobilexl:grid-cols-2 mobile:grid-cols-1'>
                                    {posts.map((post) => (
                                        <li key={post.id} className="white-box border border-[#57575733]">
                                            <img src={post.img} className='rounded-xl h-[250px] object-cover' />
                                            <div>
                                                <label className='block text-[#F0643B] my-4'>{post?.tag}</label>

                                                <a href="#" className="font-semibold text-black text-lg flex">
                                                    <span className="inset-0" />
                                                    {post.title}
                                                    <svg className='ml-auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13 11L22 2M22 2H16.6562M22 2V7.34375" stroke="black" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2" stroke="black" strokeWidth="1.5" stroke-linecap="round" />
                                                    </svg>
                                                </a>
                                                <p>{post?.desc}</p>
                                                <div className='avt-sec flex items-center mt-4'>
                                                    <img src={post.avt} className='w-14 h-14 rounded-full' />
                                                    <div className='ml-3'>
                                                        <p className='text-black font-bold'>{post?.avtname}</p>
                                                        <p>{post.date}</p>
                                                    </div>
                                                </div>
                                                {/* <ul className="flex gap-2 /50" aria-hidden="true">
                                                    <li>{post.date}</li>
                                                    <li aria-hidden="true">&middot;</li>
                                                    <li>{post.commentCount} comments</li>
                                                    <li aria-hidden="true">&middot;</li>
                                                    <li>{post.shareCount} shares</li>
                                                </ul> */}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </TabPanel>
                        ))}
                    </TabPanels>
                </TabGroup>
            </section>

        </Layout>
    );
}

export default Blog;